import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyClientsSales.vue?vue&type=template&id=62635dc5"
import script from "./MoleculeEditionBillingAcademyClientsSales.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyClientsSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports